<template>
  <div style="display: inline" class="ml-10">
    <el-button 
      type="default" size="small" 
      @click="openList()" icon="el-icon-document">
        Listar documentos
    </el-button>
    <el-dialog title="Listado de documentos" :visible.sync="dialogListVisible" :destroy-on-close="true">
      <el-row :gutter="20">
        <el-col :span="10" :offset="0">
          <el-input v-model="document" @clear="document=null" @blur="(document == '') ? document = null : document = document" placeholder="Número de documento" size="normal" clearable></el-input>
        </el-col>
        <el-col :span="10" :offset="0">
          <el-date-picker
            v-model="date_end"
            value-format="yyyy-MM-dd"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="a"
            start-placeholder="Fecha inicial"
            end-placeholder="Fecha final"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4" :offset="0">
          <el-button type="primary" size="default" icon="el-icon-search" @click="getAdjust()" :loading="loading">Buscar</el-button>
        </el-col>
      </el-row>
      <el-row  :gutter="20">
        <el-table :data="list" empty-text="No hay ajustes" width="100%">
          <el-empty slot="empty" description="No hay datos"></el-empty>
          <el-table-column
            property="consecutivo"
            label="Documento"
          ></el-table-column>
          <el-table-column property="fecha" label="Fecha"></el-table-column>
          <el-table-column
            property="branch.razon_social"
            label="Sucursal"
          ></el-table-column>
          <el-table-column
            property="observacion"
            label="Observación"
          ></el-table-column>
          <el-table-column prop="actioions" label="Acciones" width="180">
            <template slot-scope="scope">
              <el-button
                @click.native.prevent="editDocument(list[scope.$index])"
                type="primary"
                plain
                round
                size="mini"
                icon="el-icon-edit"
              >
              </el-button>
              <el-popconfirm v-if="list[scope.$index].detail_count == 0"
                confirm-button-text='Confirmar'
                cancel-button-text='Cancelar'
                icon="el-icon-info"
                icon-color="red"
                title="Confirmar eliminación"
                @confirm="deleteRow(list[scope.$index])"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  plain
                  round
                  size="mini"
                  icon="el-icon-document-delete"
                  class="ml-10"
                >
                </el-button>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <div
          v-if="list.length > 0"
          class="pagination-box"
          style="text-align: end; padding-top: 10px"
        >
          <el-pagination
            layout="total, prev, pager, next"
            :page-size="page_size"
            :total="total_rows"
            @current-change="handleCurrentPage"
          ></el-pagination>
        </div>
      </el-row>
    </el-dialog>
  </div>
</template>
<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'
import { getAdjustInputOutput } from "@/api/inputOutputAdjust";
import { deleteDocument } from "@/api/document";
export default {
  name: "ListComponent",
  data() {
    return {
      popoverVisible: false,
      loading: false,
      dialogListVisible: false,
      list: [],
      sucursal_id: null,
      type_document: null,
      //paginate
      page_size: 8,
      current_page: 1,
      total_rows: 0,
      // filter
      pickerOptions: {
        shortcuts: [
          {
            text: "Última semana",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Último mes",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Últimos tres meses",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      date_start: null,
      date_end: null,
      document: null,
    };
  },
  computed:{
    ...mapGetters(['isLogged'])
  },
  methods: {
    ...mapMutations(['SET_EDITING', 'SET_DOCUMENT_ID', 'SET_AUDITORY_ID']),
    ...mapActions(['inputAndOutputAdjust/editDocumentAction']),
    openList() {
      this.dialogListVisible = true;
      this.sucursal_id = this.isLogged.branch.id;
      this.type_document = this.$route.meta.typeDocument;
      this.getAdjust();
    },
    getAdjust() {
      let me = this;
      me.loading = true
      if (me.date_end != null || me.document != null) {
        me.current_page = 1;
      }
      getAdjustInputOutput(
        me.page_size,
        me.current_page,
        me.sucursal_id,
        me.type_document,
        me.document,
        me.date_end,
      )
      .then(({ data }) => {
        me.list = data.data;
        me.total_rows = data.total;
        me.loading = false
      })
      .catch((e) => {
        console.log(e);
        me.$message.error("Error al consultar ajustes.");
        me.loading = false
      });
    },
    handleCurrentPage(val) {
      this.current_page = val;
      this.getAdjust();
    },
    deleteRow(row){
      deleteDocument(row.id).then(({ data }) => {
        this.$message.success("Ajuste eliminado");
        this.getAdjust();
        console.log(data);
      }).catch((e) => {
        console.log(e);
        this.$message.error("Error al eliminar ajuste.");
      })
      console.log(row.id);
    },
    editDocument(row){
      this['inputAndOutputAdjust/editDocumentAction'](row.id)
      this.dialogListVisible = false;
    }
  },
};
</script>